import { BlackPearlTemplate, IBannerComponent, ISignatureComponent } from "@blackpearlmail/cerberus"

export function updateImage(
    template: BlackPearlTemplate,
    position: string,
    imageSettings: ImageSettings
): BlackPearlTemplate {
    return {
        ...template,
        components: [
            ...template.components.map((component) => {
                if (component.type === "LogoComponent" || component.type === "BannerComponent") {
                    if (component.name === getImageName(position)) {
                        return {
                            ...component,
                            ...imageSettings,
                        } as IBannerComponent
                    }
                }

                return component
            }),
        ],
    }
}

export function updateProfileImage(template: BlackPearlTemplate, width: number, height: number): BlackPearlTemplate {
    return {
        ...template,
        components: [
            ...template.components.map((component) => {
                if (component.type === "SignatureComponent") {
                    return {
                        ...component,
                        ...{
                            profileImage: {
                                horizontalAlignment: "left",
                                width: width,
                                height: height,
                                verticalAlignment: "top",
                            },
                        },
                    } as ISignatureComponent
                }
                return component
            }),
        ],
    }
}

function getImageName(position: string) {
    switch (position) {
        case "top":
            return "image at top"
        case "middle":
            return "image above signature"
        default:
            return "image below signature"
    }
}

export type ImageSettings = {
    url: string | null
    format?: string | null
    height?: number | null
    width?: number | null
}

export function getImageTrackingLabel(type: string, active?: boolean) {
    switch (type) {
        case "logo":
            return active ? "top image on" : "top image off"

        case "banner":
            return active ? "bottom image on" : "bottom image off"

        case "profile":
            return active ? "profile on" : "profile off"
    }
}
